module.exports = __webpack_public_path__ + "static/media/burn_header_mobile.dfb9b5d6.png";